import React from 'react';
import { 
  BdsModal, 
  BdsGrid, 
  BdsTypo, 
  BdsButton,
} from 'blip-ds/dist/blip-ds-react';
import { BlipLoadingComponent } from '../../../components/BlipLoading/BlipLoadingComponent';
import { ModalContent } from '../styles';
import { WhatsAppGetSettingsCalling } from '../typing/models/whatsapp-get-settings-calling.interface';
import { WhatsAppCallingStatus } from '../typing/enums/whatsapp-calling-status.enum';
import { WhatsAppCallingCallbackPermission } from '../typing/enums/whatsapp-calling-callback-permission.enum';

interface CallsStatusModalProps {
  onClose: () => void;
  phoneNumberSettings?: WhatsAppGetSettingsCalling;
  isLoading: boolean;
  translate: any;
}

const CallsStatusModal: React.FC<CallsStatusModalProps> = ({
  onClose,
  phoneNumberSettings,
  isLoading,
  translate,
}) => {
  return (
    <BdsModal id="calls-status-modal" size="dynamic">
      <ModalContent direction='column'>
        <BdsTypo variant="fs-20" margin={false} className='mb4' bold="bold">
          {translate.modal.title}
        </BdsTypo>

        {isLoading && <BlipLoadingComponent />}
        
        {phoneNumberSettings && (
          <BdsGrid direction='column' gap="2" justifyContent='flex-start'>
            <BdsTypo variant="fs-14" margin={false}>
              {translate.modal.calls}: {phoneNumberSettings?.calling?.status === WhatsAppCallingStatus.ENABLED ? translate.modal.enabled : translate.modal.disabled}
            </BdsTypo>
            <BdsTypo variant="fs-14" margin={false}>
              {translate.modal.phoneNumber}: {phoneNumberSettings?.phoneNumber}
            </BdsTypo>
            <BdsTypo variant="fs-14" margin={false}>
              {translate.modal.callbackPermission}: {phoneNumberSettings?.calling?.callbackPermissionStatus === WhatsAppCallingCallbackPermission.ENABLED ? translate.modal.enabled : translate.modal.disabled}
            </BdsTypo>
          </BdsGrid>
        )}
        
        {!phoneNumberSettings && !isLoading && (
          <BdsTypo variant="fs-14" margin={false}>
            {translate.modal.empty}
          </BdsTypo>
        )}
        
        <BdsGrid gap="1" justifyContent="flex-end" className='mt4'>
          <BdsButton variant="ghost" onClick={onClose}>
            {translate.modal.cancelButton}
          </BdsButton>
        </BdsGrid>
      </ModalContent>
    </BdsModal>
  );
};

export default CallsStatusModal;